import React from 'react';
import { useParams } from 'react-router-dom';
import ScheduleForm from '../../components/schedule/ScheduleForm';
import Card from '../../components/common/Card';

const NewSchedulePage: React.FC = () => {
  const { teamId } = useParams<{ teamId?: string }>();

  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-semibold mb-6">Create New Schedule</h1>
      
      <div className="py-6">
        <Card>
          <div className="px-6 py-4 border-b border-gray-200">
            <h2 className="text-lg font-medium text-gray-900">Schedule Details</h2>
            <p className="mt-1 text-sm text-gray-500">
              Enter the details for the new scheduling period.
            </p>
          </div>
          
          <div className="px-6 py-4">
            <ScheduleForm teamId={teamId} />
          </div>
        </Card>
      </div>
    </div>
  );
};

export default NewSchedulePage; 